import { ErrorHandler, Injectable, Injector } from '@angular/core';
import * as _ from 'lodash';

import { AlertAndNotificationsService } from './alert-and-notifications.service';

const MAX_RECORDED_EXCEPTIONS = 5;

// Angular creates this during bootstrapModule, before AngularJS exists, so anything backed by the
// AngularJS injector is resolved lazily through Injector instead of the constructor.
@Injectable({
  providedIn: 'root'
})
export class AppErrorHandler extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  handleError(error: any) {
    this.recordException(error);
    super.handleError(error);
  }

  /** Records an exception in localStorage; shared with the AngularJS `$exceptionHandler` decorator. */
  recordException(exception: any) {
    const previousException = window.localStorage.getItem('exception');

    if (previousException === String(exception)) {
      console.log('Not raising ticket as the previous exception was same');
      return;
    }
    const exceptionsString = window.localStorage.getItem('exceptions');
    let previousExceptions = exceptionsString ? JSON.parse(exceptionsString) : [];
    if (!Array.isArray(previousExceptions)) {
      previousExceptions = [];
    }
    if (previousExceptions.length < MAX_RECORDED_EXCEPTIONS) {
      console.log('Raising error ticket');
      // api call to create support ticket
      // const requestBody = {
      //     error: exception.message,
      //     stack: exception.stack
      // };
      // this.injector.get(GenericService).addObject(this.injector.get(StorageService).get('baseurl') + 'api/uierrorsupport/createUISupportTicket', requestBody).subscribe((data) => {
      //     console.log('support ticket request sent');
      // }, (error) => {
      //     console.log('support ticket request fail');
      // });
      window.localStorage.setItem('exception', exception);
      previousExceptions.push(exception.error);
      window.localStorage.setItem('exceptions', JSON.stringify(previousExceptions));
    } else {
      console.log('Not raising ticket as calls have exceeded the limit of 5');
    }
  }

  /** Reports an API error that carries a developer message, with a danger banner. */
  throwError(apiError: any) {
    if (!_.isUndefined(apiError.developerMsg) && !_.isNull(apiError.developerMsg)) {
      try {
        throw new Error(apiError.message);
      } catch (exception) {
        this.recordException(exception);
        console.error(exception, apiError.developerMsg);
        this.injector.get(AlertAndNotificationsService).showBannerMessage(exception, 'danger');
      }
    }
  }
}
